import {
    getFormDataOrRepopulateUtil,
    updateFormDataWithValidationUtil,
    createFormDataWithValidationUtil
} from '@insticator/insticator-ui';



// IUI FORM UTILS WRAPPERS

export const getFormDataOrRepopulate = (formName, fetchFormDataCallUtil, hasStoredData, id) =>
     getFormDataOrRepopulateUtil(formName, fetchFormDataCallUtil, hasStoredData, id, getFormFetchErrorMessage(formName));


export const updateFormDataWithValidation = (formName, fields, patchFormDataCallUtil, updatedFormData, id, successAction, failAction) =>
    updateFormDataWithValidationUtil(formName, fields, patchFormDataCallUtil, updatedFormData, id, successAction, failAction, !isAuthForm(formName), getFormSaveMessage(formName));

export const createFormDataWithValidation = (formName, fields, patchFormDataCallUtil, updatedFormData, successAction, failAction) =>
    createFormDataWithValidationUtil(formName, fields, patchFormDataCallUtil, updatedFormData, successAction, failAction, !isAuthForm(formName), getFormSaveMessage(formName));



//-=-=-= HELPERS -=-=-=-=//

const isAuthForm = formName => !!['signin', 'completesignup', 'resetpassword', 'completepasswordreset'].includes(formName);


//-=-=-= MESSAGES -=-=-=-=//

const getFormSaveMessage = formName => {
    let success = null;
    let error = null;
    switch (formName) {
        case 'generalInformation':
            success = 'Your General information has been saved Successfully';
            error = 'There was a problem saving your General Information';
            break;
        case 'editUser':
            success = 'You have successfully updated this users information';
            error = 'There was a problem updating this users information';
            break;
        case 'addUser':
            success = 'User has been added successfully';
            error = 'There was an issue adding this User';
            break;
        case 'WIRE':
            success = 'You have saved your wire transfer information';
            error = 'There was an issue updating your wire transfer information';
            break;
        case 'PAYPAL':
            success = 'Your Paypal information has been saved';
            error = 'There was an issue saving your paypal data';
            break;
        case 'CHECKS':
            success = 'Check information updated Successfully';
            error = 'We could not process your check information';
            break;
        case 'ACH':
            success = 'We saved your direct deposit information!!!';
            error = 'Please check your network, we could not process your direct deposit form';
            break;
        case 'personalInformationForm':
            success = 'Your profile information has been saved successfully';
            error = 'There was a problem saving your profile information';
            break;
        default:
            success = isAuthForm(formName) ? null : 'Your information has been saved successfully';
            error = isAuthForm(formName) ? null : 'Woops, something wrong. Please try again later.';
    }
    return { success, error };
};

const getFormFetchErrorMessage = formName => {
    switch (formName) {
        case 'generalInformation':
            return 'There was a problem fetching your General Information';
        case 'editUser':
            return 'There was a problem fetching this users information';
        case 'addUser':
            return 'There was an issue fetching this User';
        case 'WIRE':
            return 'There was an issue fetching your wire transfer information';
        case 'PAYPAL':
            return 'There was an issue fetching your paypal data';
        case 'CHECKS':
            return 'We could not fetch your check information';
        case 'ACH':
            return 'Please check your network, we could not fetch your direct deposit form';
        default:
            return 'Woops, something wrong: Network error. Please try again later.';
    }
};
